import React from "react";

const ProductShowcase1 = () => {
  return (
    <div className="row bg-white rounded-4 shadow overflow-hidden w-100">
      {/* Right Image Section */}
      <div className="col-md-6 order-first order-md-last d-flex justify-content-center align-items-center py-4">
        <div
          className="rounded-4 overflow-hidden"
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            padding: "10px 0",
          }} // Added padding
        >
          <img
            src="hmldpe.jpg" // Replace with actual image
            alt="Product"
            className="w-100 h-100 object-fit-cover"
            style={{ borderRadius: "16px" }}
          />
        </div>
      </div>

      {/* Left Content Section */}
      <div className="col-md-6 p-3 d-flex flex-column justify-content-center order-last order-md-first">
        <h2 className="fw-bold text-black">HMLDPE Bags</h2>
        <p className="text-muted">
          HMLDPE bags are durable, lightweight, and resistant to wear, making
          them ideal for industrial and commercial packaging.
        </p>

        <ul className="text-muted">
          <li className="text-danger fw-semibold">
            High strength & flexibility
          </li>
          <li className="text-danger fw-semibold">Moisture & tear-resistant</li>
          <li className="text-danger fw-semibold">
            Suitable for various industries
          </li>
        </ul>

        <a
          href="#contactus"
          className="btn btn-danger mt-3 px-4 py-2 fw-semibold shadow-sm"
        >
          Contact
        </a>
      </div>
    </div>
  );
};

export default ProductShowcase1;
